export enum LanguageType {
  PL = "pl",
  EN = "en",
}
